// AttendanceCorrectionReportView

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { EMPLOYEE_ATTENDANCE_CORRECTION } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import dayjs from "dayjs";
import { ChevronLeftIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AttendanceCorrectionReportView = () => {

    const [attendanceCorrectionReportView, setAttendanceCorrectionReportViewData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()
    const AttendanceCorrectionReportViewColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "actual_date",
            Header: "Date",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "actual_status",
            Header: "Attendance Status",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "actual_check_in",
            Header: "Check In",
            filterable: true,
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "actual_check_out",
            Header: "Check Out",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "actual_break_hrs",
            Header: "Break Hrs",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "actual_overtime",
            Header: "Overtime",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "modified_date",
            Header: "Mod Date",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "modified_status",
            Header: "Mod Status",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "modified_check_in",
            Header: "Mod Check In",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "modified_check_out",
            Header: "Mod Check Out",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "modified_break_hrs",
            Header: "Mod Break Hrs",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "modified_overtime",
            Header: "Mod Overtime",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "modified_user",
            Header: "Mod Username",
            Cell: ({ value }) => value ?? "-",
        },
    ];

    return (
        <div className="p-4 dark:bg-gray-900 rounded-lg dark:shadow-md font-sans">
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate('/reports') }} className=" cursor-pointer" />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                        Attendance Correction Report ({totalRecords})
                    </h1>
                </span>
            </div>

            <Reactable
                columns={AttendanceCorrectionReportViewColumns}
                data={attendanceCorrectionReportView}
                setData={setAttendanceCorrectionReportViewData}
                setTotalCount={setTotalRecords}
                url={EMPLOYEE_ATTENDANCE_CORRECTION}
                serverSide={true}
                tableHeight="calc(100vh - 310px)"
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isFromToDateRequired={true}
            />
        </div >
    );
}

export default AttendanceCorrectionReportView;